import React, { useEffect, useRef, useState } from "react";
import http from "../http";
import { useReactToPrint } from "react-to-print";
import { useParams } from "react-router-dom";
import moment from "moment";

export default function NoAuthInvoice() {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [invoiceData, setInvoiceData] = useState({});
  const [organization, setOrganization] = useState({});
  const { orgId, invoiceId } = useParams();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    http
      .post(`no-auth-invoice`, { org_id: orgId, invoice_id: invoiceId })
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          setInvoiceData({
            invoice: res.data.invoice,
            invoiceDetails: res?.data?.invoice?.details || [],
          });
          setOrganization(res?.data?.org);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [orgId, invoiceId]);
  console.log(invoiceData);

  return (
    <>
      {loading ? (
        <div className="divLoader">
          <svg
            className="svgLoader"
            viewBox="0 0 100 100"
            width="10em"
            height="10em"
          >
            <path
              ng-attr-d="{{config.pathCmd}}"
              ng-attr-fill="{{config.color}}"
              stroke="none"
              d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
              fill="#51CACC"
              transform="rotate(179.719 50 51)"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                calcMode="linear"
                values="0 50 51;360 50 51"
                keyTimes="0;1"
                dur="1s"
                begin="0s"
                repeatCount="indefinite"
              ></animateTransform>
            </path>
          </svg>
        </div>
      ) : (
        <div>
          <div className="d-flex justify-content-end mt-5">
            <button
              className="btn btn-sm btn-primary me-5"
              onClick={() => {
                handlePrint();
              }}
            >
              Print
            </button>
          </div>
          <div className="container mt-4">
            <div
              style={{ paddingLeft: "35px", paddingRight: "35px" }}
              ref={componentRef}
              className="invoice-print"
            >
              <div className="invoice-pharmacy-details d-flex align-items-center">
                <img
                  src={organization?.logo}
                  className="img-fluid"
                  style={{ height: "80px" }}
                  alt=""
                />
                <div className="text-center flex-grow-1">
                  <div style={{ marginLeft: "-80px" }}>
                    <h5>{organization?.name}</h5>
                    <p>Location : {organization?.address}</p>
                    <p>Tel : {organization?.mobile}</p>
                    <h6 className="mt-2">Invoice</h6>
                  </div>
                </div>
              </div>
              <div className="invoice-date invoice-border-dashed d-flex justify-content-between">
                <div>
                  <p> Name: {invoiceData?.invoice?.member?.member_name}</p>
                  <p> Address: {invoiceData?.invoice?.member?.address}</p>
                  <p> Mobile: {invoiceData?.invoice?.member?.mobile}</p>
                  {/* <p>Sales Person : Dummy </p> */}
                </div>
                <div>
                  <p style={{ textAlign: "end" }}>
                    Invoice No :{invoiceData?.invoice?.invoice_no}
                  </p>
                  <p style={{ textAlign: "end" }}>
                    Date :
                    {moment(invoiceData?.invoice?.date).format("DD/MM/YYYY")}
                  </p>
                  <p style={{ textAlign: "end" }}>
                    Print Date : {moment().format("DD-MM-YYYY hh:mm A")}
                  </p>
                </div>
              </div>
              <div className="invoice-item-table">
                <table>
                  <tr className="invoice-border-dashed">
                    <td width={"50%"}>Item</td>
                    <td width={"15%"} className="text-right">
                      Qty
                    </td>
                    <td width={"10%"} className="text-right">
                      Unit
                    </td>
                    <td width={"10%"} className="text-right">
                      Price
                    </td>
                    <td width={"15%"} className="text-end">
                      Total Price
                    </td>
                  </tr>
                  {invoiceData?.invoiceDetails?.map((item, i) => (
                    <tr key={i}>
                      <td width={"50%"}>
                        {item.name ? item.name : item.drug?.macrohealth_sg}
                      </td>
                      <td width={"10%"} className="text-start">
                        {item.pcs || item.qty}
                      </td>
                      <td width={"10%"} className="text-start">
                        {item.unit}
                      </td>
                      <td width={"10%"} className="text-start">
                        {item.sellingPrice}
                      </td>
                      <td width={"15%"} className="text-end">
                        {item?.total_price}
                      </td>
                    </tr>
                  ))}
                  <tr className="invoice-border-dashed-top">
                    <td colSpan={4} className="text-end fw-bolder">
                      Sub Total :
                    </td>
                    <td className="text-end">
                      {Number(invoiceData.invoice?.grand_total).toFixed(2)}
                    </td>
                  </tr>

                  <tr>
                    <td colSpan={4} className="text-end">
                      Delivery Charge :
                    </td>
                    <td className="text-end">
                      {parseFloat(
                        invoiceData?.invoice?.delivery_charge || 0
                      ).toFixed(2)}
                    </td>
                  </tr>

                  <tr>
                    <td colSpan={4} className="text-end">
                      Discount :
                    </td>
                    <td className="text-end">
                      {parseFloat(invoiceData?.invoice?.special_discount || 0)}{" "}
                    </td>
                  </tr>
                  {/* <tr>
                       <td colSpan={3} className='text-end'>
                         Special Discount :
                       </td>
                       <td className='text-end'>{0} </td>
                     </tr> */}
                  <tr className="invoice-border-dashed-top">
                    <td colSpan={4} className="text-end fw-bold">
                      Grand Total :
                    </td>
                    <td className="text-end">
                      {parseFloat(
                        parseFloat(invoiceData?.invoice?.grand_total || 0) -
                          parseFloat(
                            invoiceData?.invoice?.special_discount || 0
                          )
                      ).toFixed(2)}
                    </td>
                  </tr>
                  <tr className="invoice-border-dashed-top mt-3">
                    <td colSpan={3} className="text-end fw-bolder">
                      Last Due :{" "}
                    </td>
                    <td>{invoiceData?.invoice?.last_due_date}</td>
                    <td className="text-end">
                      {invoiceData?.invoice?.last_due}
                    </td>
                  </tr>
                  <tr className="invoice-border-dashed-top mt-3">
                    <td colSpan={4} className="text-end fw-bolder">
                      Paid :{" "}
                    </td>
                    <td className="text-end">
                      {invoiceData?.invoice?.paid_amount}
                    </td>
                  </tr>
                  <tr className="invoice-border-dashed-top mt-3">
                    <td colSpan={4} className="text-end fw-bolder">
                      Present Due :{" "}
                    </td>
                    <td className="text-end">
                      {invoiceData?.invoice?.present_due}
                    </td>
                  </tr>
                </table>
              </div>
              <div className=" invoice-creator mt-1">
                <p>Provided By: {invoiceData?.invoice?.created_by}</p>
                {/* <p>Time : {new Date().toLocaleTimeString()}</p> */}
                {/* <p>Date : {new Date().toLocaleDateString('en-GB')} </p> */}
              </div>

              <div className="d-flex justify-content-center branding-section mt-5">
                <p>Thank You</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
